module.exports = __webpack_public_path__ + "assets/img/budapark6-640.469c6887.webp";